import { render, staticRenderFns } from "./StockIntransit.vue?vue&type=template&id=474631b7"
import script from "./StockIntransit.vue?vue&type=script&lang=js"
export * from "./StockIntransit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports